module.exports = __webpack_public_path__ + "static/media/carrot.a1f89096.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/carrot.svg
// module id = 211
// module chunks = 0